import type { PrefetchContext, PrefetchedDataProps } from 'src/shared/prefetch';

import { prefetchStartAPetitionPageDataFromApi, useStartAPetitionPageDataFromApi } from './pageData';

export type StartAPetitionPagePrefetchedContext = Readonly<{
	pageData: Parameters<typeof useStartAPetitionPageDataFromApi>[0];
}>;

export type StartAPetitionPageCombinedState = ReturnType<typeof useStartAPetitionPageDataFromApi>;

export function usePageContext(prefetchedData?: StartAPetitionPagePrefetchedContext): StartAPetitionPageCombinedState {
	return useStartAPetitionPageDataFromApi(prefetchedData?.pageData);
}

export async function prefetchPageContext(context: PrefetchContext): Promise<StartAPetitionPagePrefetchedContext> {
	const pageData = await prefetchStartAPetitionPageDataFromApi(context);

	return { pageData };
}

export type StartAPetitionPagePrefetchedDataProps = PrefetchedDataProps<StartAPetitionPagePrefetchedContext>;
